import { render } from "./positionManagement.vue?vue&type=template&id=501dc14d&ts=true"
import script from "./positionManagement.vue?vue&type=script&lang=ts"
export * from "./positionManagement.vue?vue&type=script&lang=ts"

import "./positionManagement.vue?vue&type=style&index=0&id=501dc14d&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__